
export default {
  methods: {
    async refreshCaptcha() {
      if (this.$refs.smartCaptcha && this.$refs.smartCaptcha.refresh) {
        await this.$refs.smartCaptcha.refresh();
      }
    }
  }
}
